import { Column, Item, Paging, Toolbar } from 'devextreme-react/data-grid';
import { LoadPanel } from 'devextreme-react/load-panel';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Button as RxButton } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import api from '../../../services/api-configuration';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import useFormatMessage from '../../../utils/useFormatMessage';
import BayiFormPopup from './BayiFormPopup';
export const SevkiyatYerleri = () => {

    const [paginationState, setPaginationState] = useState({
        pageSize: 10,
        pageIndex: 0
    });

    const [type, setType] = useState("create");
    const [formData, setFormData] = useState({
        id: 0,
        "address_definition": "",
        "aladin_code": "",
        "aladin_name": "",
        "authorized_info": "",
        "brand_id": null,
        "code": "",
        "company_title": "",
        "create_user_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
        "dealer_code": "",
        "distance": null,
        "email": "",
        "excel_data": "",
        "group_company_title": "",
        "group_region_id": null,
        "is_active": true,
        "latitude": 0,
        "location": "",
        "longitude": 0,
        "phone1": "",
        "phone2": "",
        "special_notes": "",
        "standard_address_id": 0,
        "tax_number": "",
        "tax_office": "",
        "is_warehouse": false,
        "update_user_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),

    });



    const { t } = useFormatMessage();
    const [dataSources, setDataSources] = useState([]);
    const ref = useRef();

    const [isPopupVisible, setPopupVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await api.post("/shippingLocation/getAll");
            let all_data = response.data.data || []
            setDataSources(
                all_data.filter((item) => (item.id !== 20))
            );
        } catch (error) {
            console.error("Error fetching locations:", error);
            toast.error(t("Hata oluştu"));
        } finally {
            setLoading(false);
        }
    };


    return (

        <>
            <Breadcrumb current={t("Sevkiyat Yerleri")} />
            <Card className="p-4">
                <LoadPanel
                    visible={loading}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    // shadingColor="rgba(0,0,0,0.4)"
                    position={{ of: '#dataGrid' }}
                />
                <DatagridCustom
                    id="dataGrid"
                    dataSource={dataSources}
                    reff={ref}
                    style={{ height: "70vh" }}
                    showBorders={true}
                    columnAutoWidth={false}
                    width="100%"
                    allowColumnResizing={false}
                    remoteOperations={false}
                    onOptionChanged={(e) => {
                        if (e.fullName === "paging.pageIndex") {
                            setPaginationState(prev => ({
                                ...prev,
                                pageIndex: e.value
                            }));
                        }
                        if (e.fullName === "paging.pageSize") {
                            setPaginationState(prev => ({
                                ...prev,
                                pageSize: e.value
                            }));
                        }
                    }}
                    summary={{
                        totalItems: [{
                            column: "brand",
                            summaryType: "count",
                            displayFormat: "Toplam: {0}"
                        }]
                    }}
                >
                    <Paging
                        enabled={true}
                        pageSize={paginationState.pageSize}
                    />
                    <Column dataField="brand" caption={t("Marka")} dataType="string" width={100} fixed={true} />
                    <Column dataField="code" caption={t("Bayi Kod")} dataType="string" width={100} fixed={true} />
                    <Column dataField="group_company_title" caption={t("Irsaliye/Grupaj Görünen Bayi")} dataType="string" width={200} fixed={true} />
                    <Column dataField="excel_data" caption={t("Excel Verisi")} dataType="string" width={140} fixed={true} />
                    <Column dataField="aladin_code" caption={t("Aladin Kodu / Adı")} dataType="string" width={150} fixed={true}
                        calculateDisplayValue={(data) => {
                            if (data.aladin_name === null || data.aladin_name === "") {
                                return `-`
                            }
                            return `${data.aladin_code} / ${data.aladin_name}`
                        }}
                    />
                    {/* <Column dataField="aladin_name" caption={t("Aladin Adı")} dataType="string" /> */}

                    <Column dataField="address_definition" caption={t("Adres")} dataType="string" width={300} fixed={true}
                        cellRender={(data) => {
                            return (
                                <div style={{
                                    whiteSpace: 'normal',
                                    wordWrap: 'break-word',
                                    height: '40px',
                                    overflow: 'hidden'
                                }}>
                                    {data.data.address_definition}
                                </div>
                            );
                        }}
                    />
                    <Column dataField="phone1" caption={t("Telefon")} dataType="string" width={130} fixed={true}
                        calculateDisplayValue={(data) => {
                            // telefon formatında dön (...) ... ....
                            return data.phone1.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2 $3')
                        }}
                    />

                    <Column dataField="authorized_info" caption={t("Yekili kişi")} dataType="string" width={200} fixed={true}
                        cellRender={(data) => {
                            return (
                                <div style={{
                                    whiteSpace: 'normal',
                                    wordWrap: 'break-word',
                                    height: '40px',
                                    overflow: 'hidden'
                                }}>
                                    {data.data.authorized_info}
                                </div>
                            );
                        }}
                    />

                    <Column dataField="is_active" caption={t("Aktif")} dataType="boolean" width={70} fixed={true}
                        customizeText={(cellInfo) => {

                            return cellInfo.value === true ? "Evet" : cellInfo.value === false ? "Hayır" : cellInfo.value
                        }}
                        lookup={{
                            dataSource: [
                                { id: true, name: 'Evet' },
                                { id: false, name: 'Hayır' }
                            ],
                            displayExpr: 'name',
                            valueExpr: 'id'
                        }}
                    />
                    <Column dataField="is_hal_dealer" caption={t("HAL")} dataType="boolean" width={60} />

                    <Column caption='İşlemler' width={60} fixed={true} allowSorting={false}
                        allowExporting={false}
                        cellRender={(e) => {
                            return (
                                <div className='d-flex justify-content-center'>

                                    <i className="fa fa-edit"
                                        style={{
                                            fontSize: "20px",
                                            color: "blue",
                                            cursor: "pointer",
                                            marginRight: "10px"
                                        }}
                                        onClick={() => {
                                            setFormData(e.data)
                                            setType("update")
                                            setPopupVisible(true)
                                        }}
                                    ></i>
                                </div>
                            )
                        }
                        } />

                    <Column dataField="brand_equivalent" caption={t("Marka Eşdeğeri")} dataType="string" width={0} fixed={true} allowColumnResizing={false} />
                    <Column dataField="company_title" caption={t("Şirket Adı")} dataType="string" width={0} fixed={true} allowColumnResizing={false} />
                    <Column dataField="group_region" caption={t("Grup Bölgesi")} dataType="string" width={0} fixed={true} allowColumnResizing={false} />
                    <Column dataField="location" caption={t("Konum")} dataType="string" width={0} fixed={true} allowColumnResizing={false} />
                    <Column dataField="standard_address" caption={t("Standart Adres")} dataType="string" width={0} fixed={true} allowColumnResizing={false}
                        cellRender={(data) => {
                            return (
                                <div style={{
                                    whiteSpace: 'normal',
                                    wordWrap: 'break-word',
                                    height: '40px',
                                    overflow: 'hidden'
                                }}>
                                    {data.data.standard_address}
                                </div>
                            );
                        }}
                    />
                    <Column dataField="phone2" caption={t("Telefon 2")} dataType="string" width={0} fixed={true} allowColumnResizing={false}
                        calculateDisplayValue={(data) => {
                            if (!data.phone2 || data.phone2 === "") return "-";
                            return data.phone2.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2 $3')
                        }}
                    />
                    <Column dataField="email" caption={t("E-posta")} dataType="string" width={0} fixed={true} allowColumnResizing={false}
                        calculateDisplayValue={(data) => {
                            return data.email || "-";
                        }}
                    />
                    <Column dataField="tax_number" caption={t("Vergi Numarası")} dataType="string" width={0} fixed={true} allowColumnResizing={false}
                        calculateDisplayValue={(data) => {
                            return data.tax_number || "-";
                        }}
                    />
                    <Column dataField="tax_office" caption={t("Vergi Dairesi")} dataType="string" width={0} fixed={true} allowColumnResizing={false}
                        calculateDisplayValue={(data) => {
                            return data.tax_office || "-";
                        }}
                    />
                    <Column dataField="dealer_code" caption={t("RRDI Kodu")} dataType="string" width={0} fixed={true} allowColumnResizing={false}
                        calculateDisplayValue={(data) => {
                            return data.dealer_code || "-";
                        }}
                    />
                    <Column dataField="distance" caption={t("Mesafe")} dataType="number" width={0} fixed={true} allowColumnResizing={false}
                        calculateDisplayValue={(data) => {
                            return data.distance || 0;
                        }}
                    />
                    <Column dataField="latitude" caption={t("Enlem")} dataType="number" width={0} fixed={true} allowColumnResizing={false}
                        calculateDisplayValue={(data) => {
                            return data.latitude || 0;
                        }}
                    />
                    <Column dataField="longitude" caption={t("Boylam")} dataType="number" width={0} fixed={true} allowColumnResizing={false}
                        calculateDisplayValue={(data) => {
                            return data.longitude || 0;
                        }}
                    />
                    <Column dataField="is_warehouse" caption={t("Depo")} dataType="boolean" width={0} fixed={true} allowColumnResizing={false}
                        customizeText={(cellInfo) => {
                            return cellInfo.value === true ? "Evet" : cellInfo.value === false ? "Hayır" : cellInfo.value
                        }}
                        lookup={{
                            dataSource: [
                                { id: true, name: 'Evet' },
                                { id: false, name: 'Hayır' }
                            ],
                            displayExpr: 'name',
                            valueExpr: 'id'
                        }}
                    />
                    <Column dataField="special_notes" caption={t("Özel Notlar")} dataType="string" width={0} fixed={true} allowColumnResizing={false}
                        cellRender={(data) => {
                            return (
                                <div style={{
                                    whiteSpace: 'normal',
                                    wordWrap: 'break-word',
                                    height: '40px',
                                    overflow: 'hidden'
                                }}>
                                    {data.data.special_notes || "-"}
                                </div>
                            );
                        }}
                    />
                    <Column dataField="create_date" caption={t("Oluşturma Tarihi")} dataType="datetime" width={0} fixed={true} allowColumnResizing={false}
                        format="dd/MM/yyyy HH:mm"
                    />
                    <Column dataField="update_date" caption={t("Güncelleme Tarihi")} dataType="datetime" width={0} fixed={true} allowColumnResizing={false}
                        format="dd/MM/yyyy HH:mm"
                        calculateDisplayValue={(data) => {
                            return data.update_date || "-";
                        }}
                    />

                    {/* Gizli ID kolonları */}
                    <Column dataField="id" caption="" width={0} visible={false} allowColumnResizing={false} />
                    <Column dataField="brand_id" caption="" width={0} visible={false} allowColumnResizing={false} />
                    <Column dataField="group_region_id" caption="" width={0} visible={false} allowColumnResizing={false} />
                    <Column dataField="standard_address_id" caption="" width={0} visible={false} allowColumnResizing={false} />
                    <Column dataField="create_user_id" caption="" width={0} visible={false} allowColumnResizing={false} />
                    <Column dataField="update_user_id" caption="" width={0} visible={false} allowColumnResizing={false} />

                    <Toolbar>
                        <Item name="addRowButton" />
                        <Item name="exportButton" />
                        <Item location="after">
                            <RxButton
                                color="light"
                                outline
                                className='mr-2'
                                style={{
                                    border: "1px solid #c8ced3",
                                    paddingInline: "10px",
                                    background: "white",
                                }}
                                onClick={fetchData}
                            >
                                <i className="fa fa-refresh"></i>
                            </RxButton>
                            <RxButton
                                className='btn mr-2'
                                style={{
                                    paddingInline: "10px",
                                    border: "1px solid #ddd",
                                    fontWeight: "400",
                                }}
                                onClick={() => {
                                    setType("create")
                                    setPopupVisible(true)
                                }}
                            >
                                <i className="fa fa-plus"></i> &nbsp; Ekle
                            </RxButton>

                            <RxButton
                                color='success'
                                className='btn'
                                style={{
                                    width: "40px",
                                    padding: "5px 15px"
                                }}
                                onClick={(e) => {
                                    ButtonOnExporting(
                                        e,
                                        ref,
                                        `Sevkiyat Yerleri- ${moment(new Date()).format("DD/MM/YYYY")}`,
                                        "Sayfa-1"
                                    )
                                }} >
                                <i className="fa fa-file-excel-o"></i>
                            </RxButton>

                        </Item>
                    </Toolbar>
                </DatagridCustom>
                <BayiFormPopup
                    visible={isPopupVisible}
                    onHiding={() => setPopupVisible(false)}
                    fetchData={fetchData}
                    formData={formData}
                    setFormData={setFormData}
                    type={type}
                />

            </Card>
        </>
    );
};
